<template>
  <div class="settings-screen-container">
    <header>
      <h1>{{ title }}</h1>
    </header>
    <div class="settings-screen-content">
      <slot/>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SettingsScreen',
  props: {
    title: String,
  },
};
</script>

<style lang="scss" scoped>
.settings-screen-container {
  display: flex;
  flex-direction: column;
  height: 100%;

  header {
    padding: 1rem;

    h1 {
      font-weight: normal;
      padding: 0 0.5rem;
    }
  }

  .settings-screen-content {
    flex-grow: 1;
    padding: 1rem 2rem;
    overflow: auto;
  }
}
</style>
